import type { ApiStatus, UiStatus } from '../../schemas/status.schema';

// Define a conditional type to map ApiStatus to UiStatus
type MapApiToUiStatus<T extends UiStatus> = T extends 'ACTIVE'
  ? 'active'
  : T extends 'ARCHIVED'
    ? 'archived'
    : T extends 'PENDING'
      ? 'pending'
      : T extends 'REJECTED'
        ? 'rejected'
        : never;

type MapUiToApiStatus<T extends ApiStatus> = T extends 'active'
  ? 'ACTIVE'
  : T extends 'archived'
    ? 'ARCHIVED'
    : T extends 'pending'
      ? 'PENDING'
      : T extends 'rejected'
        ? 'REJECTED'
        : never;

export function mapStatusFromApi<TApiStatus extends ApiStatus>(
  apiStatus: TApiStatus,
): MapApiToUiStatus<UiStatus> {
  switch (apiStatus) {
    case 'ACTIVE':
      return 'active' as MapApiToUiStatus<UiStatus>;
    case 'ARCHIVED':
      return 'archived' as MapApiToUiStatus<UiStatus>;
    case 'PENDING':
      return 'pending' as MapApiToUiStatus<UiStatus>;
    case 'REJECTED':
      return 'rejected' as MapApiToUiStatus<UiStatus>;
    case 'DELETED':
      return 'deleted' as MapApiToUiStatus<UiStatus>;
    default:
      /**
       * TODO Throw to sentry */
      throw new Error(`Unsupported API status: ${apiStatus}`);
  }
}

export function mapStatusToApi<TUiStatus extends UiStatus>(
  uiStatus?: TUiStatus,
): MapUiToApiStatus<ApiStatus> {
  switch (uiStatus) {
    case 'active':
      return 'ACTIVE' as MapUiToApiStatus<ApiStatus>;
    case 'archived':
      return 'ARCHIVED' as MapUiToApiStatus<ApiStatus>;
    case 'pending':
      return 'PENDING' as MapUiToApiStatus<ApiStatus>;
    case 'rejected':
      return 'REJECTED' as MapUiToApiStatus<ApiStatus>;
    default:
      // Means status is not provided, so we send empty value to BE to trigger validations
      return '' as MapUiToApiStatus<ApiStatus>;
  }
}
